import 'css-chunk:src/lib/ErrorNotice/ErrorNotice.scss';export default {
  "ErrorNotice": "_ErrorNotice_18ake_1"
};